module.exports = __webpack_public_path__ + "img/avatar5.0e82c6f3.png";